var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackBus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 208.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f2f2f2;\n      }\n\n      .cls-2 {\n        fill: #e3e3e3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17,0H0c9.4,0,17,7.6,17,17v174.1c0,9.4-7.6,17-17,17h17c8.3,0,15-6.7,15-15V15c0-8.3-6.7-15-15-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.4,56.3h0c1.5,0,2.8-1.3,2.8-2.8v-17.7c0-1.5-1.3-2.8-2.8-2.8h0c-1.5,0-2.8,1.3-2.8,2.8v17.7c0,1.6,1.2,2.8,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.4,175.1h0c1.5,0,2.8-1.3,2.8-2.8v-17.7c0-1.5-1.3-2.8-2.8-2.8h0c-1.5,0-2.8,1.3-2.8,2.8v17.7c0,1.6,1.2,2.8,2.8,2.8Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBus);
export default __webpack_public_path__ + "static/media/backBus.2eef437437a167d0024ee39158ed43fd.svg";
export { ForwardRef as ReactComponent };